var React = require('react');

function BoxCenter (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Kawa","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"kawa-","transform":"translate(-538.000000, -6174.000000)","fill":"#F5CFC7"},React.createElement("g",{"id":"Group-22","transform":"translate(157.000000, 6163.000000)"},React.createElement("polygon",{"id":"Rectangle-Copy-2","points":"381 11.0977783 725 29.2787476 725 259.865692 485.276855 274.404053 381 242.803436"})))));
}

BoxCenter.defaultProps = {"preserveAspectRatio":"none","width":"344px","height":"264px","viewBox":"0 0 344 264","version":"1.1"};

module.exports = BoxCenter;

BoxCenter.default = BoxCenter;
